import React from 'react';
import {
    DatePickerSingleSelect,
    DatePickerMultiSelect,
    DropdownMultiSelect,
    DropdownSingleSelect,
    NumberSingleSelect,
    NumberMultiSelect,
    PositiveNegative,
    TextboxSingleSelect,
    TimePickerSingleSelect,
    TimePickerMultiSelect,
    DateTimePickerMultiSelect,
    DateTimePickerSingleSelect
} from "./CellFormatingHelper";

const Conditions = ({
    attribute,
    operator,
    condition1,
    onChangeCondition1,
    condition2,
    onChangeCondition2
}) => {
    const operatorValue = typeof operator === "object" ? operator.value : operator;

    const attributeType = attribute.attributeType === "Mirror" ? attribute.attribute.attributeType : attribute.attributeType;

    if (attributeType === "Number") {
        if (
            operatorValue === "Equal to" ||
            operatorValue === "Not equal to" ||
            operatorValue === "Greater than" ||
            operatorValue === "Less than" ||
            operatorValue === "Greater than or equal to" ||
            operatorValue === "Less than or equal to"
        ) {
            return (
                <NumberSingleSelect
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        } else if (operatorValue === "Between") {
            return (
                <NumberMultiSelect
                    condition1={condition1}
                    condition2={condition2}
                    onChangeCondition1={onChangeCondition1}
                    onChangeCondition2={onChangeCondition2}
                />
            )
        } else if (
            operatorValue === "Positive" ||
            operatorValue === "Negative"
        ) {
            return (
                <PositiveNegative />
            )
        }
    } else if (attributeType === "Boolean") {
        if (
            operatorValue === "Equal to" ||
            operatorValue === "Not equal to"
        ) {
            return (
                <DropdownSingleSelect
                    data={["True", "False"]}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        }
    } else if (attributeType === "DateTime") {
        const dateTimeType = attributeType === "Mirror" ? attribute.attribute.dateTimeType : attribute.dateTimeType;
        if (
            operatorValue === "Equal to" ||
            operatorValue === "Not equal to" ||
            operatorValue === "Greater than" ||
            operatorValue === "Less than" ||
            operatorValue === "Greater than or equal to" ||
            operatorValue === "Less than or equal to"
        ) {
            let Component = DatePickerSingleSelect;
            if (dateTimeType === "time") {
                Component = TimePickerSingleSelect;
            } else if (dateTimeType === "datetime") {
                Component = DateTimePickerSingleSelect;
            }
            return (
                <Component
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        } else if (operatorValue === "Between") {
            let Component = DatePickerMultiSelect;
            if (dateTimeType === "time") {
                Component = TimePickerMultiSelect;
            } else if (dateTimeType === "datetime") {
                Component = DateTimePickerMultiSelect;
            }
            return (
                <Component
                    condition1={condition1}
                    condition2={condition2}
                    onChangeCondition1={onChangeCondition1}
                    onChangeCondition2={onChangeCondition2}
                />
            )
        } else if (operatorValue === "Days selected") {
            return (
                <DropdownMultiSelect
                    data={[
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ]}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                    allowCustom={false}
                    placeholder={"Please select ...."}
                />
            )
        }
    } else if (attributeType === "Tags") {
        if (operatorValue === "Equal to") {
            return (
                <TextboxSingleSelect
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        } else if (operatorValue === "In") {
            return (
                <DropdownMultiSelect
                    data={[]}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                    allowCustom={true}
                    placeholder={"Please type ...."}
                />
            )
        }
    } else if (attributeType === "Picklist String") {

        const picklistValues = attribute.picklist ? attribute.picklist.split("ɖ") : [];

        if (
            operatorValue === "Equal to" ||
            operatorValue === "Not equal to"
        ) {
            return (
                <DropdownSingleSelect
                    data={picklistValues}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        } else if (
            operatorValue === "In" ||
            operatorValue === "Not in"
        ) {
            return (
                <DropdownMultiSelect
                    data={picklistValues}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                    allowCustom={false}
                    placeholder={"Please select ...."}
                />
            )
        }
    } else if (attributeType === "State Field") {
        const statefield = attribute.statefield ? attribute.statefield : [];
        const data = statefield.map((item) => item.name);
        if (operatorValue === "Equal to" || operatorValue === "Not equal to") {
            return (
                <DropdownSingleSelect
                    data={data}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                />
            )
        } else if (operatorValue === "In" || operatorValue === "Not in") {
            return (
                <DropdownMultiSelect
                    data={data}
                    condition1={condition1}
                    onChangeCondition1={onChangeCondition1}
                    allowCustom={false}
                    placeholder={"Please select ...."}
                />
            )
        }

    }
}

export default Conditions;